import { render, staticRenderFns } from "./AiBdMailList.vue?vue&type=template&id=77b34fed&scoped=true"
import script from "./AiBdMailList.vue?vue&type=script&lang=js"
export * from "./AiBdMailList.vue?vue&type=script&lang=js"
import style0 from "./AiBdMailList.vue?vue&type=style&index=0&id=77b34fed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b34fed",
  null
  
)

export default component.exports